import React from "react";

// packages
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// component
import Pill from "../../../common/Pill";

// styles
import styles from "./WaitingDeliveryBroker.module.scss";

const WaitingDeliveryBroker = () => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName={"waitingDeliveryBroker"}
      Lefticon={
        <img src={"../../../assets/images/svg/waitingDeliveryBroker.svg"} />
      }>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_implementing_payment")}
      </p>
    </Pill>
  );
};

export default WaitingDeliveryBroker;
